import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { Graphics } from '../models/Dashboard'
import { PATH } from '../app.api'

@Injectable()
export class DashboardService {
	constructor(private http: HttpClient) {}
		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}